export default __webpack_public_path__ + "static/media/backgroundPossumus.4bac4b30.svg";